import { render, staticRenderFns } from "./HomeNotice.vue?vue&type=template&id=70b85bea&scoped=true"
import script from "./HomeNotice.vue?vue&type=script&lang=js"
export * from "./HomeNotice.vue?vue&type=script&lang=js"
import style0 from "./HomeNotice.vue?vue&type=style&index=0&id=70b85bea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b85bea",
  null
  
)

export default component.exports